import React from 'react';
import { Product } from '../../utils/grocyApi.ts';
import ProductPicker from '../../components/ProductPicker.tsx';
import ProductGroupSelectorWithAI from './ProductGroupSelectorWithAI.tsx';

interface ProductSelectionSectionProps {
  // Manual product selection mode
  isCreating: boolean;
  onToggleCreating: (creating: boolean) => void;
  
  // Existing product selection
  searchTerm: string;
  onSearchTermChange: (term: string) => void;
  selectedProduct: Product | null;
  onSelectProduct: (product: Product) => void;
  
  // New product creation
  newProductName: string;
  onNewProductNameChange: (name: string) => void;
  newProductGroupId: number | null;
  onNewProductGroupIdChange: (id: number | null) => void;
}

const ProductSelectionSection: React.FC<ProductSelectionSectionProps> = ({
  isCreating,
  onToggleCreating,
  searchTerm,
  onSearchTermChange,
  selectedProduct,
  onSelectProduct,
  newProductName,
  onNewProductNameChange,
  newProductGroupId,
  onNewProductGroupIdChange,
}) => {
  if (!isCreating) {
    return (
      <div className="purchase-controls__field">
        <ProductPicker
          searchTerm={searchTerm}
          onSearchTermChange={onSearchTermChange}
          onSelect={onSelectProduct}
          autoFocus
          showCreateNew
          onCreateNew={(term: string) => {
            onToggleCreating(true);
            onNewProductNameChange(term);
          }}
          showList={Boolean(searchTerm && !selectedProduct)}
        />
      </div>
    );
  }

  return (
    <>
      <div className="purchase-controls__field">
        <label>New Product Name:</label>
        <input
          type="text"
          className="purchase-controls__text-input"
          value={newProductName}
          onChange={(e) => onNewProductNameChange(e.target.value)}
          placeholder="Enter product name"
        />
      </div>

      <div className="purchase-controls__field">
        <label>Product Group:</label>
        <ProductGroupSelectorWithAI
          productName={newProductName}
          value={newProductGroupId}
          onChange={onNewProductGroupIdChange}
        />
      </div>

      <div className="purchase-controls__field">
        <button
          type="button"
          onClick={() => onToggleCreating(false)}
          className="purchase-controls__cancel-create"
        >
          Cancel New Product
        </button>
      </div>
    </>
  );
};

export default ProductSelectionSection;
